import Table from '@/components/Table/Table.jsx'
import TableChooseComponent from '../_COMPONENT/TableChooseExternalComponent.jsx'

export default function TableChooseOr(props) {
    const columns = [
        {
            title: '组织对象名称',
            dataIndex: 'ooName',
            component: <Table.ViewText />,
        },

        {
            title: '组织对象代码',
            dataIndex: 'ooNo',
            component: <Table.ViewText />,
        },

        {
            title: '岗位角色标题',
            dataIndex: 'orName',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseComponent
            columns={columns}
            {...props}
        />
    )
}
